module.exports = __webpack_public_path__ + "img/passport-stamps-4.71f62248.jpg";